import React, {useEffect, useState} from 'react';
import PropTypes from 'prop-types';
import {makeStyles} from '@material-ui/core/styles';
import Dialog from '@material-ui/core/Dialog';
import DialogTitle from '@material-ui/core/DialogTitle';
import DialogContent from '@material-ui/core/DialogContent';
import DialogActions from '@material-ui/core/DialogActions';
import Grid from '@material-ui/core/Grid';
import FormControl from '@material-ui/core/FormControl';
import Select from '@material-ui/core/Select';
import MenuItem from '@material-ui/core/MenuItem';
import {SaveOutlined} from '@material-ui/icons';
import LabelValue from '../../../shared/labelvalue/LabelValue.js';
import ContainedButton from '../../../shared/buttons/ContainedButton.tsx';
import TextButton from '../../../shared/buttons/TextButton.tsx';
import {useToast} from '../../../shared/toast/ToastProvider.tsx';
import useUpdate from '../../../../hooks/useUpdate.js';
import {CorSituacaoInscricao} from '../../components/inscricao/StatusSituacaoInscricao.jsx';
import {URL_INSCRICOES_SITUACAO} from '../../../../constants/index.js';

const useStyles = makeStyles(() => ({
    root: {
        width: 500,
        maxWidth: '100%'
    },
    contentRoot: {overflowY: 'initial'}
}));

/* Alteração da situação de uma inscrição (módulo EDITSTATUS). */
export default function DialogSituacaoInscricao(props) {
    const {open, onClose, inscricao, situacoes, onSalvo} = props;
    const classes = useStyles();
    const {createToast} = useToast();
    const [update, salvando] = useUpdate({returnInnerLoadingState: true});
    const [situacao, setSituacao] = useState('');

    // A cada abertura volta para a situação atual da inscrição escolhida.
    useEffect(() => {
        if (open && inscricao) {
            setSituacao(inscricao.situacao ? inscricao.situacao.codigo : '');
        }
    }, [open, inscricao]);

    const handleSalvar = () => {
        update(URL_INSCRICOES_SITUACAO(inscricao.id), {situacao}, () => {
            createToast({severity: 'success', message: 'Situação atualizada com sucesso!'});
            onClose();
            onSalvo && onSalvo();
        });
    };

    return (
        <Dialog
            open={open}
            onClose={onClose}
            maxWidth={false}
            classes={{paper: classes.root}}
            scroll='body'
            aria-labelledby='dialog-situacao-inscricao-titulo'>
            <DialogTitle id='dialog-situacao-inscricao-titulo'>
                {inscricao ? `Alterar situação da inscrição ${inscricao.id}` : 'Alterar situação'}
            </DialogTitle>
            <DialogContent classes={{root: classes.contentRoot}}>
                <Grid container spacing={3}>
                    <Grid item xs={12}>
                        <LabelValue label='Situação *'>
                            <FormControl variant='outlined' fullWidth>
                                <Select
                                    value={situacao}
                                    onChange={event => setSituacao(event.target.value)}>
                                    {(situacoes || []).map(item => (
                                        <MenuItem key={item.codigo} value={item.codigo}>
                                            <CorSituacaoInscricao codigo={item.codigo}/>
                                            {item.descricao}
                                        </MenuItem>
                                    ))}
                                </Select>
                            </FormControl>
                        </LabelValue>
                    </Grid>
                </Grid>
            </DialogContent>
            <DialogActions>
                <TextButton onClick={onClose}>Fechar</TextButton>
                <ContainedButton
                    startIcon={<SaveOutlined/>}
                    disabled={salvando || !situacao}
                    onClick={handleSalvar}>
                    Salvar
                </ContainedButton>
            </DialogActions>
        </Dialog>
    );
}

DialogSituacaoInscricao.propTypes = {
    open: PropTypes.bool.isRequired,
    onClose: PropTypes.func.isRequired,
    /* Inscrição da linha: {id, situacao: {codigo, descricao}}. */
    inscricao: PropTypes.shape({
        id: PropTypes.number,
        situacao: PropTypes.shape({codigo: PropTypes.string})
    }),
    /* Situações do GET /inscricoes/situacoes: [{codigo, descricao}]. */
    situacoes: PropTypes.array,
    /* Chamado depois de gravar (a página recarrega a lista). */
    onSalvo: PropTypes.func
};
